const esLocale = {
	title: 'Lavu 4 está en marcha',
	subtitle:
		'El Panel de Control tiene nuevas funcionalidades que optimizarán tu experiencia de administración de restaurantes.',
	dashboard: 'Tablero',
	dashboardDesc: 'Visualiza las ventas y el trabajo de tu organización.',
	endOfDay: 'Fin del día',
	endOfDayDesc:
		'Realiza un seguimiento diario de la información y analiza tus resúmenes.',
	workforce: 'Empleados',
	workforceDesc:
		'Administra el staff y la agenda de acuerdo a cómo funcione tu organización.',
	transactions: 'Transacciones',
	transactionsDesc:
		'Verifica y revisa cualquier pago o transacción de órdenes.',
	seeLater: 'Ver más tarde',
	seeLavu4: 'Ver Lavu 4',
};

export default esLocale;
